let nextId = 1;
export const generateId = (prefix = 'id') => `${prefix}_${nextId++}`;
 
export const initialProducts = [
  {
    _id: generateId('prod'),
    name: "Candy Camo Skimboard",
    description: "Eye-catching skimboard with a pink-and-green candy camo pattern. Great for beginner to intermediate riders seeking style and performance.",
    imageUrl: "/Product Photos/Candy Camo.jpeg",
    category: "Skimboards",
    price: 275.63,
    stock: 3525,
    tags: ["skimboards"],
    rating: 4.0,
    numRatings: 12,
    likes: 0,
  },
  {
    _id: generateId('prod'),
    name: "Carbon Fiber Pro Skimboard",
    description: "Elite carbon fiber skimboard designed for high-speed maneuvers and durability. Ideal for advanced riders and pros.",
    imageUrl: "/Product Photos/Carbon Fiber Pro.jpeg",
    category: "Skimboards",
    price: 568.54,
    stock: 1324,
    tags: ["skimboards"],
    rating: 4.7,
    numRatings: 25,
    likes: 0,
  },
  {
    _id: generateId('prod'),
    name: "Blue Palm Tree Tee Shirt",
    description: "Cool and breezy summer shirt with blue palm tree and sunset design. Lightweight and stylish for beach outings.",
    imageUrl: "/Product Photos/BluePalmTreeShirt.png",
    category: "T-Shirts",
    price: 16.99,
    stock: 2103,
    tags: ["skimboards"],
    rating: 4.2,
    numRatings: 83,
    likes: 0,
  },
  {
    _id: generateId('prod'),
    name: "Green Island Skimboard",
    description: "Vibrant green-themed skimboard inspired by tropical islands. Perfect for carving on wet sand and small waves.",
    imageUrl: "/Product Photos/Green Island.jpeg",
    category: "Skimboards",
    price: 632.19,
    stock: 1536,
    tags: ["skimboards"],
    rating: 4.3,
    numRatings: 18,
    likes: 0,
  },
  {
    _id: generateId('prod'),
    name: "Lime Swirl Skimboard",
    description: "Bright and bold skimboard with an electric lime swirl pattern. Built for speed and smooth gliding over shallow waters.",
    imageUrl: "/Product Photos/Lime Swirl.jpeg",
    category: "Skimboards",
    price: 427.68,
    stock: 3274,
    tags: ["skimboards"],
    rating: 4.8,
    numRatings: 96,
    likes: 0,
  },
  {
    _id: generateId('prod'),
    name: "Marble Fish Skimboard",
    description: "Sleek marble-patterned skimboard with a fish-style shape for enhanced maneuverability and wave riding.",
    imageUrl: "/Product Photos/Marble Fish.jpeg",
    category: "Skimboards",
    price: 195.36,
    stock: 3522,
    tags: ["marble", "fish shape", "skimboards"],
    rating: 4.5,
    numRatings: 1150,
    likes: 0,
  },
  {
    _id: generateId('prod'),
    name: "Marble Skimboard",
    description: "Premium-grade skimboard with a minimalist marble finish. Smooth riding surface and high durability for regular beachgoers.",
    imageUrl: "/Product Photos/Marble.jpeg",
    category: "Skimboards",
    price: 941.25,
    stock: 2901,
    tags: ["marble design", "premium", "skimboards"],
    rating: 4.2,
    numRatings: 45,
    likes: 0,
  },
  {
    _id: generateId('prod'),
    name: "Purple Carbon Skimboard",
    description: "Carbon fiber skimboard in a bold purple finish. Combines advanced materials with sleek aesthetics for peak performance.",
    imageUrl: "/Product Photos/Purple Carbon.jpeg",
    category: "Skimboards",
    price: 559.57,
    stock: 1364,
    tags: ["carbon fiber", "purple", "performance", "skimboards"],
    rating: 4.6,
    numRatings: 33,
    likes: 0,
  },
  {
    _id: generateId('prod'),
    name: "Rasta Skimboard",
    description: "Colorful Rasta-inspired skimboard with red, yellow, and green stripes. A stylish pick for expressive riders of all levels.",
    imageUrl: "/Product Photos/Rasta.jpeg",
    category: "Skimboards",
    price: 92.01,
    stock: 1243,
    tags: ["rasta", "colorful", "freestyle", "skimboards"],
    rating: 4.4,
    numRatings: 19,
    likes: 0,
  },
  {
    _id: generateId('prod'),
    name: "Samurai Skimboard",
    description: "Aggressively styled skimboard with samurai-themed graphics. Built for speed, strength, and precision carving.",
    imageUrl: "/Product Photos/Samurai.jpeg",
    category: "Skimboards",
    price: 542.98,
    stock: 837,
    tags: ["samurai", "japanese style", "aggressive design", "skimboards"],
    rating: 4.1,
    numRatings: 77,
    likes: 0,
  },
  {
    _id: generateId('prod'),
    name: "Cetaphil Sheer Mineral Sunscreen Lotion",
    description: "Fragrance-free SPF 50 sunscreen with 100% mineral UV filters. Lightweight, non-greasy formula ideal for sensitive skin.",
    imageUrl: "/Product Photos/Cetaphil-Sheer-Mineral-Sunscreen-Lotion-SPF-50-Fragrance-Free-3-oz_31c4fa0f-cbeb-43d0-84ae-168d51d38f5f.0783adf0de938f2148f6902345bfee3b.png",
    category: "Accessories",
    price: 27.60,
    stock: 8553,
    tags: ["sunscreen", "spf50", "mineral", "fragrance-free"],
    rating: 4.1,
    numRatings: 77,
    likes: 0,
  },
  {
  _id: generateId('prod'),
  name: "Banana Boat Sunscreen",
  description: "Water-resistant SPF 50 sunscreen ideal for beach days. Provides broad spectrum UVA/UVB protection with a lightweight, fast-absorbing formula.",
  imageUrl: "/Product Photos/Banana Boat Sunscreen.jpg",
  category: "Accessories",
  price: 12.83,
  stock: 1658,
  tags: ["sunscreen", "spf50", "broad spectrum", "water-resistant"],
  rating: 4.1,
  numRatings: 77,
  likes: 0,
},
{
  _id: generateId('prod'),
  name: "Beach Tee Shirt",
  description: "Lightweight short-sleeve beach shirt with vibrant tropical prints. Breathable and perfect for sunny, casual outings.",
  imageUrl: "/Product Photos/Beach Shirt 1.png",
  category: "T-Shirts",
  price: 22.54,
  stock: 2532,
  tags: ["beachwear", "tropical", "casual", "summer shirt"],
  rating: 4.1,
  numRatings: 77,
  likes: 0,
},
{
  _id: generateId('prod'),
  name: "Light Blue Boardshort",
  description: "Quick-dry boardshorts with a bold color pattern. Designed for comfort, movement, and water activities.",
  imageUrl: "/Product Photos/Boardshorts 1.png",
  category: "Boardshorts",
  price: 32.10,
  stock: 3276,
  tags: ["boardshorts", "swimwear", "quick-dry", "beach"],
  rating: 4.1,
  numRatings: 77,
  likes: 0,
},

// I STOPPED HERE
{
  _id: generateId('prod'),
  name: "Dark Blue Boardshorts",
  description: "Comfortable and stylish boardshorts featuring a modern print. Great for beach games, surfing, or lounging.",
  imageUrl: "/Product Photos/Boardshort 2.png",
  category: "Boardshorts",
  price: 19.87,
  stock: 647,
  tags: ["boardshorts", "surfwear", "modern print", "activewear"],
  rating: 4.1,
  numRatings: 77,
  likes: 0,
},
{
  _id: generateId('prod'),
  name: "Black Boardshorts",
  description: "Classic fit boardshorts with drawstring waist. Durable and flexible, perfect for long days in and out of the water.",
  imageUrl: "/Product Photos/Boardshort 3.png",
  category: "Boardshorts",
  price: 21.76,
  stock: 3542,
  tags: ["classic", "durable", "drawstring", "beachwear", "boardshorts"],
  rating: 4.1,
  numRatings: 77,
  likes: 0,
},
{
  _id: generateId('prod'),
  name: "Multi-Colour Towel Set",
  description: "Set of soft, absorbent beach towels in assorted vibrant colors. Great for sunbathing, drying off, or lounging.",
  imageUrl: "/Product Photos/Bunch of Towels 1.png",
  category: "Accessories",
  price: 21.03,
  stock: 1789,
  tags: ["towels", "beach", "absorbent", "vibrant colors"],
  rating: 4.1,
  numRatings: 77,
  likes: 0,
},
{
  _id: generateId('prod'),
  name: "Teal Towels",
  description: "Colorful beach towel bundle featuring soft microfiber fabric. Lightweight and easy to pack for any adventure.",
  imageUrl: "/Product Photos/Bunch of Towels 2.png",
  category: "Accessories",
  price: 26.94,
  stock: 1000,
  tags: ["microfiber", "quick-dry", "travel-friendly", "beach essentials", "towels"],
  rating: 4.1,
  numRatings: 77,
  likes: 0,
},
{
  _id: generateId('prod'),
  name: "Seafolly Beach Bag",
  description: "Colorful beach towel bundle featuring soft microfiber fabric. Lightweight and easy to pack for any adventure.",
  imageUrl: "/Product Photos/Seafolly Beach Bag 1.png",
  category: "Accessories",
  price: 30.95,
  stock: 2543,
  tags: ["microfiber", "quick-dry", "travel-friendly", "beach essentials"],
  rating: 4.1,
  numRatings: 77,
  likes: 0,
},
{
  _id: generateId('prod'),
  name: "Large Waterproof Beach Tote Bag",
  description: "Colorful beach towel bundle featuring soft microfiber fabric. Lightweight and easy to pack for any adventure.",
  imageUrl: "/Product Photos/Large Waterproof Beach Tote Bag.png",
  category: "Accessories",
  price: 50.00,
  stock: 2543,
  tags: ["microfiber", "quick-dry", "travel-friendly", "beach essentials"],
  rating: 4.1,
  numRatings: 77,
  likes: 0,
},
// --- Sunscreen Category Products ---
{
  _id: generateId('prod'),
  name: "La Roche-Posay Anthelios Melt-in Milk Sunscreen SPF 60",
  description: "Broad spectrum SPF 60 sunscreen for face and body. Lightweight, fast-absorbing, and water resistant.",
  imageUrl: "/Product Photos/la_roche_posay.png",
  category: "Accessories",
  price: 35.99,
  stock: 1200,
  tags: ["sunscreen", "spf60", "broad spectrum", "water-resistant"],
  rating: 4.7,
  numRatings: 210,
  likes: 0,
},
{
  _id: generateId('prod'),
  name: "Skin Aqua Tone Up UV Essence SPF 50+ PA++++",
  description: "Lightweight Japanese sunscreen with lavender scent. Brightens skin tone and provides high UV protection.",
  imageUrl: "/Product Photos/skin-aqua-50-transparency-enhancing-tone-up-uv-essence-sunscreen-scent-of-lavender-scent-of-savon-293204_540x.png",
  category: "Accessories",
  price: 18.50,
  stock: 900,
  tags: ["sunscreen", "spf50", "japanese", "tone up"],
  rating: 4.5,
  numRatings: 98,
  likes: 0,
},
{
  _id: generateId('prod'),
  name: "Sun Bum Original SPF 50 Sunscreen Lotion",
  description: "Moisturizing sunscreen lotion with SPF 50. Vegan, reef-friendly, and water resistant for 80 minutes.",
  imageUrl: "/Product Photos/sunbum_sunscreen_lotion.png",
  category: "Accessories",
  price: 15.99,
  stock: 1500,
  tags: ["sunscreen", "spf50", "vegan", "reef-friendly"],
  rating: 4.6,
  numRatings: 134,
  likes: 0,
},
{
  _id: generateId('prod'),
  name: "Anessa Perfect UV Sunscreen Skincare Milk SPF 50+ PA++++",
  description: "Japanese sunscreen with strong UV protection and skincare benefits. Lightweight, non-sticky, and sweat-resistant.",
  imageUrl: "/Product Photos/sunscreenanessa.png",
  category: "Accessories",
  price: 29.99,
  stock: 800,
  tags: ["sunscreen", "spf50", "japanese", "skincare"],
  rating: 4.8,
  numRatings: 156,
  likes: 0,
},
{
  _id: generateId('prod'),
  name: "Dot & Key Watermelon Cooling Sunscreen SPF 50 PA+++",
  description: "Hydrating sunscreen with watermelon extract. SPF 50 PA+++ for broad spectrum protection and a refreshing feel.",
  imageUrl: "/Product Photos/0722aa56-d674-4034-9f82-1aa8a9cb8d131743400701211-Dot--Key-Watermelon-Cooling-Sunscreen-SPF-50-PA-With-Hyaluro-1.png",
  category: "Accessories",
  price: 22.00,
  stock: 1100,
  tags: ["sunscreen", "spf50", "watermelon", "cooling"],
  rating: 4.4,
  numRatings: 67,
  likes: 0,
},
{
  _id: generateId('prod'),
  name: "Power Long Lasting Sun Cream SPF50+ PA++++",
  description: "Long-lasting sun cream with high SPF and PA rating. Suitable for all skin types, non-greasy finish.",
  imageUrl: "/Product Photos/31500318-Power-Long-Lasting-Sun-Cream-SPF50-PA-80ml.png",
  category: "Accessories",
  price: 19.90,
  stock: 950,
  tags: ["sunscreen", "spf50", "long-lasting", "non-greasy"],
  rating: 4.3,
  numRatings: 54,
  likes: 0,
},
{
  _id: generateId('prod'),
  name: "We Are Feel Good Inc. Gentle Sunscreen Lotion SPF50+",
  description: "Gentle sunscreen lotion for sensitive skin. Broad spectrum SPF50+ and water resistant.",
  imageUrl: "/Product Photos/we-are-feel-good-inc-gentle-sunscreen-lotion-broad-spectrum-spf50-75ml_1.png",
  category: "Accessories",
  price: 24.50,
  stock: 700,
  tags: ["sunscreen", "spf50", "gentle", "sensitive skin"],
  rating: 4.5,
  numRatings: 39,
  likes: 0,
},
{
  _id: generateId('prod'),
  name: "Banana Boat Ultra Sunscreen SPF 50+",
  description: "Ultra-protection sunscreen with SPF 50+. Water-resistant and suitable for active outdoor use.",
  imageUrl: "/Product Photos/Banana_Boat_Ultra.png",
  category: "Accessories",
  price: 13.99,
  stock: 600,
  tags: ["sunscreen", "spf50", "ultra", "water-resistant"],
  rating: 4.4,
  numRatings: 58,
  likes: 0,
},
{
  _id: generateId('prod'),
  name: "Phantom-Eco Weekender Boardshorts",
  description: "Made from recycled polyester, a drawcord made from recycled materials, is packaged in recycled bags all while offering the performance benefits you need like stretch, durability, and quick dry fabric. ",
  imageUrl: "/Product Photos/phantom-ecoweekender.jpg",
  category: "Boardshorts",
  price: 30.99,
  stock: 600,
  tags: ["sunscreen", "spf50", "ultra", "water-resistant"],
  rating: 4.4,
  numRatings: 58,
  likes: 0,
},
{
  _id: generateId('prod'),
  name: "All Day Fade Boardshorts",
  description: "Recycled polyester surf suede blend fabric. A high performance fabric made from recycled PET plastic bottles.",
  imageUrl: "/Product Photos/alldayfade.jpg",
  category: "Boardshorts",
  price: 30.99,
  stock: 600,
  tags: ["boardshorts", "swimwear", "quick-dry", "beach", "men"],
  rating: 4.4,
  numRatings: 58,
  likes: 0,
},
{
  _id: generateId('prod'),
  name: "Birdwell Beach Britches Boardshorts",
  description: "Precisely tailored for the modern woman. Perfect for those active moments in the waves, on the volleyball court, or at the corner store — the refined, modern cut is tailored with a curved waistband designed to flatter the female form.",
  imageUrl: "/Product Photos/BirdwellBeachBritches.jpg",
  category: "Boardshorts",
  price: 32.99,
  stock: 600,
  tags: ["boardshorts", "swimwear", "quick-dry", "beach", "women"],
  rating: 4.4,
  numRatings: 58,
  likes: 0,
},
{
  _id: generateId('prod'),
  name: "Women's Wavefarer Boardshorts",
  description: "Recycled polyester surf suede blend fabric. A high performance fabric made from recycled PET plastic bottles.",
  imageUrl: "/Product Photos/patagonia-womens-wavefarer.jpg",
  category: "Boardshorts",
  price: 29.80,
  stock: 600,
  tags: ["boardshorts", "swimwear", "quick-dry", "beach", "women"],
  rating: 4.4,
  numRatings: 58,
  likes: 0,
},
{
  _id: generateId('prod'),
  name: "Kids 'Hello Sunshine' Straw Hat",
  description: "Perfect top off for any summer look! One size fits most children.",
  imageUrl: "/Product Photos/kidshellosunshinestrawhat.jpg",
  category: "Accessories",
  price: 28.15,
  stock: 600,
  tags: ["hats", "kids", "beach", "accessory", "children"],
  rating: 4.4,
  numRatings: 58,
  likes: 0,
},
{
  _id: generateId('prod'),
  name: "Beach Sun Hat",
  description: "Relax in style with our classic beach sun hat. Ideal for sunny days by the shore.",
  imageUrl: "/Product Photos/braysbeachsunhat.jpg",
  category: "Accessories",
  price: 35.18,
  stock: 600,
  tags: ["hats", "beach", "accessory", "unisex", "sunhat"],
  rating: 4.4,
  numRatings: 58,
  likes: 0,
},
{
  _id: generateId('prod'),
  name: "Beach Fedora Sun Hat",
  description: "Relax in style with our classic beach sun hat shaped like a fedora. Ideal for sunny days by the shore.",
  imageUrl: "/Product Photos/PalmBeachFedoraSunHat.jpg",
  category: "Accessories",
  price: 36.23,
  stock: 600,
  tags: ["hats", "beach", "accessory", "unisex", "sunhat", "fedora"],
  rating: 4.4,
  numRatings: 58,
  likes: 0,
},
{
  _id: generateId('prod'),
  name: "One Raw Carbon Fiber Sunglasses",
  description: "Essential beach-ready sunglasses with UV protection and laid-back style.",
  imageUrl: "/Product Photos/onerawcarbonfiber.jpg",
  category: "Accessories",
  price: 69.00,
  stock: 600,
  tags: ["beach", "protection", "unisex", "glasses", "sunglasses"],
  rating: 4.4,
  numRatings: 58,
  likes: 0,
},
{
  _id: generateId('prod'),
  name: "Yellow Beach Tee Shirt",
  description: "Cool and breezy summer shirt with This Side Up's logo. Lightweight and stylish for beach outings.",
  imageUrl: "/Product Photos/YellowTShirt.jpg",
  category: "T-Shirts",
  tags: ["shirt", "t-shirt", "tee shirt"],
  price: 14.99,
  stock: 2103,
  rating: 4.2,
  numRatings: 83,
  likes: 0,
},
{
  _id: generateId('prod'),
  name: "Blue Beach Necklace",
  description: "Hollow ball necklace with blue water and sand inside to replicate the beach's appearance.",
  imageUrl: "/Product Photos/beachsandnecklace.jpg",
  category: "Accessories",
  tags: ["jewelry", "necklace"],
  price: 55.99,
  stock: 2103,
  rating: 4.2,
  numRatings: 83,
  likes: 0,
},
{
  _id: generateId('prod'),
  name: "'My Job Is Beach Tee' Shirt",
  description: "Cool and breezy summer shirt. Lightweight and stylish for beach outings.",
  imageUrl: "/Product Photos/myjobisbeach.jpg",
  category: "T-Shirts",
  tags: ["shirt", "t-shirt", "tee shirt"],
  price: 55.99,
  stock: 2103,
  rating: 4.2,
  numRatings: 83,
  likes: 0,
},
{
  _id: generateId('prod'),
  name: "Beach Tailored Jacket",
  description: "Stay stylish and protected with our lightweight beach jacket — perfect for breezy coastal days. Zip it up and head out in comfort and style.",
  imageUrl: "/Product Photos/brownbeachjacket.jpg",
  category: "Jackets",
  tags: ["jackets", "beach"],
  price: 105.99,
  stock: 2103,
  rating: 4.2,
  numRatings: 83,
  likes: 0,
},
{
  _id: generateId('prod'),
  name: "Women's Beach Coverup Jacket",
  description: "Featuring a relaxed fit, stylish silhouette, and adjustable waist tie, this jacket combines comfort with coastal elegance—your go-to for sunny strolls and seaside lounging.",
  imageUrl: "/Product Photos/beachcoverup.jpg",
  category: "Jackets",
  tags: ["jackets", "beach", "women"],
  price: 105.99,
  stock: 2103,
  rating: 4.2,
  numRatings: 83,
  likes: 0,
},
{
  _id: generateId('prod'),
  name: "Women's Tops Loose Black Coverup Cardigan",
  description: "Featuring a relaxed fit, stylish silhouette, and adjustable waist tie, this jacket combines comfort with coastal elegance—your go-to for sunny strolls and seaside lounging.",
  imageUrl: "/Product Photos/womenstopblack.jpg",
  category: "Jackets",
  tags: ["jackets", "beach", "women", "cardigan"],
  price: 105.99,
  stock: 2103,
  rating: 4.2,
  numRatings: 83,
  likes: 0,
},

];